export type Debounced<a> = {
  kind: 'clean' | 'dirty'
  value: a
} 

export const Debounced = {
  clean: <a,>(value: a): Debounced<a> => ({
    kind: 'clean', value
  }),
  dirty: <a,>(value: a): Debounced<a> => ({
    kind: 'dirty', value
  }) 
}